import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import api from "../api";

const fmtTgl = (v) => {
  const d = new Date(v + "T00:00:00");
  return isNaN(d) ? v : d.toLocaleDateString("id-ID", { day: "2-digit", month: "short" });
};
const fmtNum = (v) => Number(v).toLocaleString("id-ID");

export const GrafikHarian = ({ prefix = "dash" }) => {
  const [days, setDays] = useState(14);
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get(`/dashboard/grafik-harian?days=${days}`)
      .then(({ data }) => setData(data.rows))
      .catch(() => setData([]));
  }, [days]);

  const picker = (
    <div className="flex items-center gap-1">
      {[7, 14, 30].map((d) => (
        <Button key={d} data-testid={`${prefix}-grafik-harian-${d}`} size="sm"
          variant={days === d ? "default" : "outline"}
          className={`h-7 px-2.5 text-xs ${days === d ? "bg-emerald-700 hover:bg-emerald-800 text-white" : "border-zinc-300 text-zinc-600"}`}
          onClick={() => setDays(d)}>
          {d} hari
        </Button>
      ))}
    </div>
  );

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <Card className="border-zinc-200 shadow-sm">
        <CardHeader className="pb-2 flex flex-row items-center justify-between space-y-0">
          <CardTitle className="text-base font-semibold tracking-tight">Total Tonase Diangkut Harian (Trip Selesai)</CardTitle>
          {picker}
        </CardHeader>
        <CardContent className="h-72" data-testid={`${prefix}-chart-tonase-harian`}>
          {data === null ? (
            <div className="h-full flex items-center justify-center text-zinc-400"><Loader2 className="w-5 h-5 animate-spin" /></div>
          ) : (
            <ResponsiveContainer width="100%" height="100%" minHeight={200}>
              <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E4E4E7" />
                <XAxis dataKey="tanggal" tickFormatter={fmtTgl} tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} tickFormatter={fmtNum} />
                <Tooltip labelFormatter={fmtTgl} formatter={(v) => `${fmtNum(v)} KG`} />
                <Legend />
                <Bar dataKey="CPO" stackId="t" name="CPO" fill="#047857" />
                <Bar dataKey="Palm Kernel" stackId="t" name="Palm Kernel" fill="#F59E0B" />
                <Bar dataKey="Cangkang" stackId="t" name="Cangkang" fill="#78716C" radius={[3, 3, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          )}
        </CardContent>
      </Card>
      <Card className="border-zinc-200 shadow-sm">
        <CardHeader className="pb-2">
          <CardTitle className="text-base font-semibold tracking-tight">Total Pengeluaran Uang Jalan Harian</CardTitle>
        </CardHeader>
        <CardContent className="h-72" data-testid={`${prefix}-chart-uang-jalan-harian`}>
          {data === null ? (
            <div className="h-full flex items-center justify-center text-zinc-400"><Loader2 className="w-5 h-5 animate-spin" /></div>
          ) : (
            <ResponsiveContainer width="100%" height="100%" minHeight={200}>
              <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E4E4E7" />
                <XAxis dataKey="tanggal" tickFormatter={fmtTgl} tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} tickFormatter={fmtNum} />
                <Tooltip labelFormatter={fmtTgl} formatter={(v) => `Rp ${fmtNum(v)}`} />
                <Legend />
                <Bar dataKey="uang_jalan" name="Uang Jalan (Rp)" fill="#DC2626" radius={[3, 3, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
